export default "__VITE_ASSET__4b721168__"